import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CuentasService  {

  baserApiUrl:string=environment.baseApi
  constructor(public http:HttpClient) { }

  getCuentasByUser(data:any){
    return this.http.get(`${this.baserApiUrl}cuentas?user=${data}`)
  }

  getCuentasExtinguidas(data:any){
    return this.http.get(`${this.baserApiUrl}cuentas/extinguidas?${data}`)
  }

  getCuentasByCliente(data:any){
    return this.http.get(`${this.baserApiUrl}cuentas/cliente/?cliente=${data}`)
  }

  extinguirCuenta(data:any){
    return this.http.post(`${this.baserApiUrl}cuentas/extinguir`,data)
  }

  anularExinticionCuenta(data:any){
    return this.http.put(`${this.baserApiUrl}cuentas/anular-extincion/`,data)
  }
}
